export const PREFECTURE_SLUGS = Object.freeze({
  hokkaido: '北海道',
  aomori: '青森県',
  iwate: '岩手県',
  miyagi: '宮城県',
  akita: '秋田県',
  yamagata: '山形県',
  fukushima: '福島県',
  ibaraki: '茨城県',
  tochigi: '栃木県',
  gunma: '群馬県',
  saitama: '埼玉県',
  chiba: '千葉県',
  tokyo: '東京都',
  kanagawa: '神奈川県',
  niigata: '新潟県',
  toyama: '富山県',
  ishikawa: '石川県',
  fukui: '福井県',
  yamanashi: '山梨県',
  nagano: '長野県',
  gifu: '岐阜県',
  shizuoka: '静岡県',
  aichi: '愛知県',
  mie: '三重県',
  shiga: '滋賀県',
  kyoto: '京都府',
  osaka: '大阪府',
  hyogo: '兵庫県',
  nara: '奈良県',
  wakayama: '和歌山県',
  tottori: '鳥取県',
  shimane: '島根県',
  okayama: '岡山県',
  hiroshima: '広島県',
  yamaguchi: '山口県',
  tokushima: '徳島県',
  kagawa: '香川県',
  ehime: '愛媛県',
  kochi: '高知県',
  fukuoka: '福岡県',
  saga: '佐賀県',
  nagasaki: '長崎県',
  kumamoto: '熊本県',
  oita: '大分県',
  miyazaki: '宮崎県',
  kagoshima: '鹿児島県',
  okinawa: '沖縄県',
});

export const PREFECTURE_TO_SLUG = Object.freeze(
  Object.fromEntries(Object.entries(PREFECTURE_SLUGS).map(([slug, prefecture]) => [prefecture, slug]))
);

export const AGE_GROUP_SLUGS = Object.freeze({
  '20s': '20代',
  '30s': '30代',
  '40s': '40代',
  '50s': '50代',
  '60s': '60代以上',
  mixed: '幅広い年代',
});

export function getPrefectureBySlug(slug) {
  return PREFECTURE_SLUGS[slug] || '';
}

export function getPrefectureSlug(prefecture) {
  return PREFECTURE_TO_SLUG[prefecture] || '';
}

export function getPrefecturePath(prefecture) {
  const slug = getPrefectureSlug(prefecture);
  return slug ? `/p/${slug}` : '/recruitments';
}

export function getAreaPath(areaId) {
  return areaId ? `/a/${areaId}` : '/recruitments';
}

export function getAgeGroupLabelBySlug(ageSlug) {
  return AGE_GROUP_SLUGS[ageSlug] || '';
}

export function getAgeGroupPath(ageSlug) {
  return AGE_GROUP_SLUGS[ageSlug] ? `/age/${ageSlug}` : '/recruitments';
}

export function getPrefectureAgePath(prefecture, ageSlug) {
  const prefecturePath = getPrefecturePath(prefecture);
  return AGE_GROUP_SLUGS[ageSlug] && prefecturePath !== '/recruitments'
    ? `${prefecturePath}/${ageSlug}`
    : prefecturePath;
}
